// Order Repository - Repository Pattern
import apiService from '../api.service';

class OrderRepository {
  // Get all orders with relations
  async getAll(params = {}) {
    return apiService.get('/orders', {
      ...params,
      with: 'product,user', // Include relations
    });
  }

  // Get single order with relations
  async getById(id) {
    return apiService.get(`/orders/${id}`, {
      with: 'product,user',
    });
  }

  // Create order
  async create(data) {
    return apiService.post('/orders', data);
  }

  // Update order (general update)
  async update(id, data) {
    return apiService.put(`/orders/${id}`, data);
  }

  // Update order status only (handles stock/sold_count changes)
  async updateStatus(id, status) {
    return apiService.patch(`/orders/${id}/status`, { status });
  }

  // Update payment status only
  async updatePaymentStatus(id, paymentStatus) {
    return apiService.patch(`/orders/${id}/payment`, { payment_status: paymentStatus });
  }

  // Delete order
  async delete(id) {
    return apiService.delete(`/orders/${id}`);
  }

  // Bulk operations
  async bulkDelete(ids) {
    return apiService.post('/orders/bulk-delete', { ids });
  }
}

export default new OrderRepository();
